import { useRef, useState } from "react";
import type { OpcionSede } from "../../types/accesosOrganizacion.types";

// Configuración "Simple" dentro del modal: compañía, sucursal y sedes con los
// selects de siempre. Compañía y sucursal se aplican al formulario al cambiarlas
// (cargan sus catálogos, como antes); las sedes son un borrador hasta "Aplicar".
// Al cancelar se restauran la compañía y la sucursal previas.
export const useConfiguracionSimple = ({ watch, setValue, obtenerSucursalesPorCompania, obtenerSedesPorSucursal }: any) => {
    const [sedes, setSedes] = useState<OpcionSede[]>([])
    const previa = useRef({ compania: "", sucursal: "" })

    const iniciar = (iniciales: OpcionSede[]) => {
        setSedes(iniciales)
        previa.current = { compania: `${watch("compania") ?? ""}`, sucursal: `${watch("sucursal") ?? ""}` }
    }

    // Cambia la compañía padre: el árbol de sedes cambia y se limpia la selección.
    const cambiarCompania = async (valor: string) => {
        setValue("compania", valor)
        setSedes([])
        await obtenerSucursalesPorCompania(valor)
        await obtenerSedesPorSucursal(watch("sucursal"))
    }

    const cambiarSucursal = async (valor: string) => {
        setValue("sucursal", valor)
        await obtenerSedesPorSucursal(valor)
    }

    const restaurar = async () => {
        const { compania, sucursal } = previa.current
        if (`${watch("compania") ?? ""}` !== compania) {
            setValue("compania", compania)
            await obtenerSucursalesPorCompania(compania)
            await obtenerSedesPorSucursal(sucursal)
        }
        setValue("sucursal", sucursal)
    }

    return { sedes, setSedes, iniciar, cambiarCompania, cambiarSucursal, restaurar }
}
